module.exports = __webpack_public_path__ + "img/9788996771869.a0d90f73.jpg";